













































import Component from 'vue-class-component';
import LoginContainer from '@/views/authentication/login-container/LoginContainer.component';
import { Prop } from 'vue-property-decorator';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { LoginRequest } from '@/models/request/LoginRequest';
import {
  CHANGE_EXPIRED_PASSWORD,
  IS_RECAPTCHA_V2_USED,
  SET_AUTH_ERRORS,
  SET_AUTH_LOADING_MODE,
} from '@/types/authentication.types';
import { RecaptchaNamespace } from '@/globals/recaptcha-namespace.global';

@Component({
  components: {
    LoginContainer,
  },
})
export default class PasswordExpiredComponent extends FeedbackComponent {

  @Prop(String) public idNumber!: string;
  @Prop(String) public userId!: string;
  @Prop(String) public indexNum!: string;
  @Prop(String) public officeNum!: string;

  @Action(CHANGE_EXPIRED_PASSWORD, StoreNamespace.AUTHENTICATION) public changeExpiredPassword;

  @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;
  @Mutation(SET_AUTH_ERRORS, StoreNamespace.AUTHENTICATION) public setAuthErrors;

  @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

  private expiredAuth: LoginRequest = {} as LoginRequest;
  private newPasswordRepeat: string = '';

  public mounted() {
    if (!this.idNumber && !this.userId) {
      this.$router.push({ name: 'login' });
    }
  }

  public async onLogin(recaptchaV2Response: string): Promise<void> {
    if (this.expiredAuth.newPassword === this.newPasswordRepeat) {
      this.changeExpiredPassword({
        ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
        recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.PASSWORD_EXPIRED),
        userId: Number(this.userId),
        indexNum: Number(this.indexNum),
        officeNum: this.officeNum || null,
        oldPassword: this.expiredAuth.oldPassword,
        newPassword: this.expiredAuth.newPassword,
      });
    } else {
      this.setAuthLoadingMode(false);
      this.setAuthErrors([this.$t('login.passwords_not_matched').toString()]);
    }
  }

}
